'use strict';

import { useEffect, useMemo } from 'react';
import { io } from 'socket.io-client';
import { useAuthStore } from 'shared/stores';
import { getAccessToken } from '../services/auth';
import { useHandleCargoInvalidateOne } from './use-handle-cargo-invalidate-one';
import { useHandleCargoTripInvalidateMany } from './use-handle-cargo-trip-invalidate-many';
import { useHandleInvoiceSyncUpdateStatus } from './use-handle-invoice-sync-update-status';
import { useHandleOrderInvalidateMany } from './use-handle-order-invalidate-many';
import { useHandleOrderInvalidateOne } from './use-handle-order-invalidate-one';
import { useHandleTripInvalidateOne } from './use-handle-trip-invalidate-one';

export const useSocket = () => {
  const { isAuth, user } = useAuthStore();

  const socket = useMemo(() => {
    const accessToken = getAccessToken();

    return io(import.meta.env.VITE_API_SOCKET_URL, {
      autoConnect: false,
      path: import.meta.env.VITE_API_SOCKET_PATH,
      extraHeaders: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
  }, [isAuth, user]);

  useEffect(() => {
    socket.connect();

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  useHandleCargoInvalidateOne(socket);
  useHandleOrderInvalidateMany(socket);
  useHandleOrderInvalidateOne(socket);
  useHandleTripInvalidateOne(socket);
  useHandleCargoTripInvalidateMany(socket);
  useHandleInvoiceSyncUpdateStatus(socket);
};
